import { render } from "./ProposalActivity.vue?vue&type=template&id=511d8ef8&scoped=true"
import script from "./ProposalActivity.vue?vue&type=script&lang=js"
export * from "./ProposalActivity.vue?vue&type=script&lang=js"

import "./ProposalActivity.vue?vue&type=style&index=0&id=511d8ef8&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511d8ef8"]])

export default __exports__